var NotificationTypeAction = /** @class */ (function () {
    function NotificationTypeAction() {
    }
    return NotificationTypeAction;
}());
export { NotificationTypeAction };
var NotificationType = /** @class */ (function () {
    function NotificationType() {
    }
    return NotificationType;
}());
export { NotificationType };
var NotificationModel = /** @class */ (function () {
    function NotificationModel(data) {
        this.accountNumber = null;
        this.branch = null;
        this.channelEntry = null;
        this.creationDate = null;
        this.data = null;
        this.deletedDate = null;
        this.description = null;
        this.fromUser = null;
        this.id = null;
        this.insuredName = null;
        this.isDeleted = null;
        this.isRead = null;
        this.isSeen = null;
        this.jobNumber = null;
        this.jobSubType = null;
        this.licensePlate = null;
        this.notificationGroup = null;
        this.notificationGroupId = null;
        this.notificationType = null;
        this.notificationTypeId = null;
        this.operationNumber = null;
        this.organizerCode = null;
        this.policyNumber = null;
        this.policyPeriodId = null;
        this.policyType = null;
        this.producerCode = null;
        this.readDate = null;
        this.receivedDate = null;
        this.risk = null;
        this.seenDate = null;
        this.termNumber = null;
        this.toUser = null;
        if (typeof data !== 'undefined') {
            for (var i in data) {
                if (this.hasOwnProperty(i)) {
                    this[i] = data[i];
                }
            }
        }
    }
    return NotificationModel;
}());
export { NotificationModel };
var PaymentRequestEvent = /** @class */ (function () {
    function PaymentRequestEvent() {
    }
    return PaymentRequestEvent;
}());
export { PaymentRequestEvent };
